import { Button, Card, Icon, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { StatTile } from '@/components/StatTile'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

const ORDERS = [
  { building: 'Torre Polanco', side: 'Buying', size: '$1,400', price: '1.042', spread: '+4.2%' },
  { building: 'Torre Polanco', side: 'Selling', size: '$860', price: '1.061', spread: '+6.1%' },
  { building: 'Pinheiros Retail', side: 'Buying', size: '$2,200', price: '0.984', spread: '−1.6%' },
  { building: 'Chapinero Lofts', side: 'Selling', size: '$540', price: '0.962', spread: '−3.8%' },
]

export function SecondaryMarketScreen() {
  return (
    <>
      <PageHeader
        title="Secondary market"
        subtitle="Sell before completion, if someone wants to buy. There is no guarantee one is there."
        actions={<Button variant="primary" size="md" iconStart="sell">List a holding</Button>}
      />

      <BentoGrid>
        {[
          { label: 'Open orders', value: '34', note: 'Across 4 buildings' },
          { label: 'Traded this month', value: '$84,200', note: '+12% vs August' },
          { label: 'Median time to fill', value: '9 days', note: 'When it fills at all' },
          { label: 'Transfer fee', value: '0.5%', note: 'Paid by the seller' },
        ].map((stat) => (
          <StatTile key={stat.label} stat={stat} />
        ))}

        <BentoSpan span={3}>
          <Card tone="light">
            <Card.Header>
              <Text variant="caption" weight="semibold">Open orders</Text>
              <Text variant="eyebrow" tone="secondary">Price is per $1 of original stake</Text>
            </Card.Header>
            <Stack gap={0} className="pb-mt-3">
              {ORDERS.map((order, index) => (
                <div key={`${order.building}-${index}`} className={checkout.line}>
                  <Pill tone={order.side === 'Buying' ? 'positive' : 'neutral'}>{order.side}</Pill>
                  <Stack grow gap={0} align="start">
                    <Text variant="caption" weight="semibold" truncate>{order.building}</Text>
                    <Text variant="eyebrow" tone="secondary" numeric>{order.size}</Text>
                  </Stack>
                  <Text variant="caption" weight="semibold" numeric style={{ width: '4rem', textAlign: 'right' }}>
                    {order.price}
                  </Text>
                  <Text
                    variant="caption"
                    weight="semibold"
                    numeric
                    tone={order.spread.startsWith('+') ? 'positive' : 'negative'}
                    style={{ width: '4.5rem', textAlign: 'right' }}
                  >
                    {order.spread}
                  </Text>
                </div>
              ))}
            </Stack>
          </Card>
        </BentoSpan>

        <Card tone="dark">
          <Stack direction="row" align="center" gap={3}>
            <Icon name="warning" size={20} />
            <Text variant="caption" weight="semibold" tone="onDark">Read this first</Text>
          </Stack>
          <Text variant="caption" tone="onDarkMuted" className="pb-mt-3">
            This is not a stock market. Orders can sit unfilled for weeks, prices below 1.00 mean
            selling at a loss, and a building that is still under construction has no rent to price
            against. Treat what you put in as money you will not touch until completion.
          </Text>
        </Card>
      </BentoGrid>
    </>
  )
}
